import CountryDetailMobileTabs from '../countryDetail/CountryDetailMobileTabs';

// City details intentionally use the established Country detail tab shell so
// sticky positioning, overflow fades and active-pill reveal stay in sync.
const CityDetailMobileTabs = ({ items }) => (
    <CountryDetailMobileTabs items={items} />
);

export default CityDetailMobileTabs;
